module.exports = __webpack_public_path__ + "static/5-61e2979a462953e9a849525c637f8d6d.jpg";